
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 19 21"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.551.517a1.055 1.055 0 00-.73.295 1.004 1.004 0 00-.303.712v.64a9.295 9.295 0 01-3.22 2.49 9.528 9.528 0 01-4.006.896H3.097c-.82.001-1.608.32-2.189.886A2.985 2.985 0 000 8.57v2.013c0 .801.327 1.569.908 2.135.58.566 1.368.884 2.19.885h.499l-2.48 5.644a.983.983 0 00.086.95c.094.14.222.253.372.332.15.08.319.12.49.12h4.13c.202 0 .4-.057.568-.166.169-.108.3-.263.38-.444l2.812-6.398a9.503 9.503 0 013.637 1.011 9.274 9.274 0 012.926 2.336v.642c0 .267.11.523.303.711.194.19.456.295.73.295.274 0 .536-.106.73-.295a.994.994 0 00.302-.711V1.524a.985.985 0 00-.302-.712 1.034 1.034 0 00-.73-.295zM3.097 11.59c-.274 0-.536-.106-.73-.295a.994.994 0 01-.302-.712V8.57c0-.267.109-.523.302-.711.194-.19.456-.295.73-.295H4.13v4.026H3.097zm2.417 7.046H3.63l2.212-5.033h1.883l-2.212 5.033zm11.005-4.508a11.59 11.59 0 00-7.227-2.538H6.194V7.564h3.098a11.59 11.59 0 007.226-2.54v9.104z"}})])
          )
        }
      }
    